import { Action } from '../../../common/actions/core/action';

export class NoAuthOpenPreInfoFormAction implements Action {
    constructor(public msisdn: string, public onApprove: () => void, public offerId?: string, public paymentType?: string) { }
}


// WEBPACK FOOTER //
// src/app/no-auth/components/pre-info-form-dialog/pre-info-form-dialog.action.ts